import { useTranslation } from "react-i18next";
import googleBadge from "./../../images/greyscale-short.svg";

export default function GoogleTranslateAttributionBadge() {
  const { t } = useTranslation();

  return (
    <a href="//translate.google.com" target="_blank" rel="noopener noreferrer">
      <img src={googleBadge} alt={t("Common.googleTranslateBadge.label")} />
    </a>
  );
}
